module.exports = __webpack_public_path__ + "img/soul-land3d-th.0efa834.png";